import { render, staticRenderFns } from "./OrderChange.vue?vue&type=template&id=4caf1080"
import script from "./OrderChange.vue?vue&type=script&lang=js"
export * from "./OrderChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports